/** Compatibility export; the business domain owns this implementation. */
export { IAmazonMbaColor, MBA_COLOR_SPECIFICATION } from '@domains/upload/shared';
